/* global BMS */
import betLimits from './configurations/betLimitsConfig.json';
// import {OPERATOR} from './operator';
// This object is to be injected by virgo

// export const BET_LIMITS = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
//   ? {
//     minStake: betLimits.minStake * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency],
//     maxStake: betLimits.maxStake * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency],
//     maxWinnings: betLimits.maxWinnings * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency]
//   }
//   : BMS
//     ? {
//       minStake: BMS.betLimits.minStake * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency],
//       maxStake: BMS.betLimits.maxStake * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency],
//       maxWinnings: BMS.betLimits.maxWinnings * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency]
//     }
//     : {};

export const BET_LIMITS = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? {
        minStake: betLimits.minStake,
        maxStake: betLimits.maxStake,
        maxWinnings: betLimits.maxWinnings,
        stakeDivisor: betLimits.stakeDivisor,
        minMaxStakeLimitByCategory: betLimits.minMaxStakeLimitByCategory,
        maxWinningsAutoCorrectEnabled: betLimits.maxWinningsAutoCorrectEnabled
    }
    : BMS
        ? {
            minStake: BMS.betLimits.minStake,
            maxStake: BMS.betLimits.maxStake,
            maxWinnings: BMS.betLimits.maxWinnings,
            stakeDivisor: BMS.betLimits.stakeDivisor,
            minMaxStakeLimitByCategory: BMS.betLimits.minMaxStakeLimitByCategory,
            maxWinningsAutoCorrectEnabled: BMS.betLimits.maxWinningsAutoCorrectEnabled
        }
        : {};



// WEBPACK FOOTER //
// ./src/constants/betLimits.js